import { reactive } from '@rehaje/reactive'

import { fromSpecific } from '../../decorators'
import { TypedNode } from '../../models'

import type { TypedSpecific, TypedSpecificLike } from '../../types'

export interface SnapshotSpecific extends TypedSpecificLike {
  children: TypedSpecific[]
  type: 'Snapshot'
}

export class SnapshotNode extends TypedNode {
  @fromSpecific()
  @reactive('shallow')
  children: TypedNode[] = []
}

declare global {
  export interface RehajeSpecifics {
    Snapshot: SnapshotSpecific
  }
  export interface RehajeTypedNodes {
    Snapshot: SnapshotNode
  }
}
